export default __webpack_public_path__ + "static/5-2af75f84a0dae814e72353c0124c48b1.jpg";